import axios from 'axios'
import isUndefined from 'lodash/isUndefined';
import moment from 'moment';
import i18n from '@/i18n';

import { query, groupQuery, tagSearchQuery } from "../../../config/bool-const";
import { getNextPageUrl, pagination, filters } from "../../../helpers/store";
import { filtersToQuery } from '@/helpers/filters';

let validateToken;

const state = {

  client_id: null,
  project_id: null,
  isResizing: false,
  isBusy: false, // for create Search, Group

  clonedSearch: null,
  isCloning: false,
  clonedError: false,

  searches: {
    isBusy: false,
    isInitiated: false,
    deletedQuery: null,
    queryExporting: false,
    data: [],
    pagination: {...pagination},
    filters: {...filters},
    pollingUid: null,
    compatible_tags: [],
    link_tags_error:false
  },
  group_library: {
    isBusy: false,
    isInitiated: false,
    deletedQuery: null,
    data: [],
    pagination: {...pagination},
    filters: {...filters}
  },
  tag_library: {
    isBusy: false,
    isInitiated: false,
    deletedQuery: null,
    data: [],
    countByCategory: [],
    showPrivateTags: false,
    sorted: false,
    pagination: {...pagination},
    filters: {...filters}
  },
  last_activities: {
    isBusy: false,
    isInitiated: false,
    data: [],
    pagination: {...pagination},
    filters: {...filters}
  },
  active_last_activity: null,
  reload_last_activity: false,
  search: {
    isBusy: false,
    ...query,
    errorMessage: ''
  },
  group: {
    is_group: true,
    isBusy: false,
    ...groupQuery,
    errorMessage: ''
  },
  tagSearch:{
    is_tagSearch: true,
    isBusy: false,
    ...tagSearchQuery,
    errorMessage: ''
  },
  media_types: {
    isBusy: false,
    isInitiated: false,
    data: [],
    pagination: {...pagination},
    filters: {...filters}
  },
  outlet_categories: {
    isBusy: false,
    isInitiated: false,
    data: [],
    filters: {...filters}
  },
  tagCategories: {
    // isBusy: false,
    isInitiated: false,
    data: [],
  },
  include_outlet_groups: {
    isBusy: false,
    isInitiated: false,
    deletedQuery: null,
    data: [],
    pagination: {...pagination},
    filters: {...filters}
  },
  exclude_outlet_groups: {
    isBusy: false,
    isInitiated: false,
    deletedQuery: null,
    data: [],
    pagination: {...pagination},
    filters: {...filters}
  },
  outlets: {
    isBusy: false,
    isInitiated: false,
    data: [],
    pagination: {...pagination},
    filters: {...filters}
  },
  include_outlets: {
    isBusy: false,
    isInitiated: false,
    data: [],
    pagination: {...pagination},
    filters: {...filters}
  },
  exclude_outlets: {
    isBusy: false,
    isInitiated: false,
    data: [],
    pagination: {...pagination},
    filters: {...filters}
  },
  states: [],
  tags: {
    isBusy: false,
    isInitiated: false,
    data: [],
    pagination: {...pagination},
    filters: {...filters}
  },
  twitter_filters: {
    isBusy: false,
    isInitiated: false,
    data: [],
    filters: {...filters}
  },

  twitter_searches: {
    isBusy: false,
    isInitiated: false,
    data: [],
    filters: {...filters}
  },

  search_terms_filters: {
    isBusy: false,
    isInitiated: false,
    data: [],
    filters: { ...filters }
  },

  x_channel_filters: {
    isBusy: false,
    isInitiated: false,
    data: [],
    filters: { ...filters }
  },

  query_validity: {
    isBusy: false,
    queryType: null,
    isValid: true,
    errorMessage: ''
  },

  projects: {
    isBusy: false,
    isInitiated: false,
    data: [],
    pagination: {...pagination},
    filters: {...filters}
  },
  clients: {
    isBusy: false,
    isInitiated: false,
    data: [],
    pagination: {...pagination},
    filters: {...filters}
  },
  twitter_languages: {
    isBusy: false,
    isInitiated: false,
    data: [],
    filters: {...filters}
  },
  include_influencers: {
    isBusy: false,
    isInitiated: false,
    data: [],
    pagination: {...pagination},
    filters: {...filters}
  },
  group_blocked: {
    action: '',
    group_id: null,
    searches: [],
    groups: []
  }
}
const mutations = {

  SET_CLIENT_ID(state, payload) {
    state.client_id = payload
  },
  SET_PROJECT_ID(state, payload) {
    state.project_id = payload
  },

  SET_ACTIVITY_ACTIVE(state, payload){
    state.active_last_activity = payload
  },

  SET_RELOAD_LAST_ACTIVITY(state, payload) {
    state.reload_last_activity = payload;
  },

  SET_FILTER_PARAM(state, {key, param: {key: paramKey, value}}) {
    state[key].filters[paramKey] = value
  },

  RESET_PAGINATION(state, key) {
    state[key].pagination = pagination
  },

  SET_BUSY(state, {key, value}) {
    if(!key) return state.isBusy = value
    state[key].isBusy = value
  },

  SET_CLONED_SEARCH(state, payload) {
    if(!payload || (state.clonedSearch && payload.id === state.clonedSearch.id)) return state.clonedSearch = null
    state.clonedSearch = payload
  },

  SET_CLONING(state, payload) {
    state.isCloning = payload
  },

  SET_CLONING_ERROR(state, payload) {
    state.clonedError = payload
  },

  SET_INITIATE_STATE(state, {key, value}) {
    state[key].isInitiated = value
  },

  SET_DELETING(state, {key, item}) {
    if(!key || !state[key]) return
    state[key].deletedQuery = item
  },

  SET_EXPORTING(state, {isExporting}) {
    state.searches.queryExporting = isExporting
  },

  SET_STATES(state, payload) {
    state.states = payload.filter(state => state !== "")
  },

  SET_PAGINATED_RESOURCE(state, {key, resourceData, pagination:responsePagination, reset = false}) {
    if(reset) {
      state[key].isInitiated = false
      state[key].data = []
      state[key].pagination = {...pagination}
    }

    if (key !== 'tag_library'){
      resourceData.forEach(query => state[key].data.push(query))
    } else {
      state[key].data = [...state[key].data, ...resourceData[0]]
      state[key].countByCategory = resourceData[1]
      state[key].showPrivateTags = resourceData[2]
    }
    state[key].pagination = { ...state[key].pagination, ...responsePagination }
    state[key].isInitiated = true
  },

  // set data on resource without pagianation
  SET_RESOURCE(state, {key, data, updateTotalCount = false}) {
    if (!updateTotalCount) state[key].data = data
    else {
      state[key].data = data[0]
      state[key].countByCategory = data[1]
    }
    state[key].isInitiated = true
  },

  CHANGE_TAGS_VISIBILITY(state, {tagsIds, visible}) {
    state.tag_library.data = state.tag_library.data.map(tag => {
      if(tagsIds.includes(tag.id)) {
        tag.is_private = !visible;
      }
      return tag;
    });
  },

  SET_TAG_CATEGORIES(state, {key, data}) {
    const map = new Map();
    const mergedCategories = [];
    for (const item of data) {
      map.set(item.value, item);
    }
    
    const fixedCategories = [
      {
        label: 'Competitors',
        value: 'Competitors',
        color: '#80a2c5',
      },
      {
        label: 'Organizations',
        value: 'Organizations',
        color: '#80bfc5',
      },
      {
        label: 'People',
        value: 'People',
        color: '#e097c5',
      },
      {
        label: 'Products',
        value: 'Products',
        color: '#d77083',
      },
      {
        label: 'Places',
        value: 'Places',
        color: '#cdbb83',
      }

    ]

    for (const item of fixedCategories) {
      if (!map.has(item.value)) {
        map.set(item.value, item);
      }
    }
  
    for (const value of map.values()) {
      mergedCategories.push(value);
    }
    state[key].data = mergedCategories;
    state[key].isInitiated = true
  },

  SET_TAG_SORT_ORDER(state, {sort}) {
    state.tag_library.sorted = sort;
  },    

  ADD_MORE_TAGS_BY_CATEGORY(state, {key, data}) {
    state[key].data = [...state[key].data, ...data];
  },

  TAGS_BY_SEARCH(state, {data}) {
    state.searches.compatible_tags = data;
  },

  SET_LINKED_TAGS_ERROR(state, payload) {
    state.searches.link_tags_error = payload
  },

  DELETE_TAGS(state, {tagsIds, removedFromEachCategory}) {
    state.tag_library.data = state.tag_library.data.filter(tag => !tagsIds.includes(tag.id));
    state.tag_library.countByCategory = state.tag_library.countByCategory.map(object => {
      if(removedFromEachCategory[object.category]) {
        object.count = +object.count - removedFromEachCategory[object.category];
      }
      return object;
    });
  },

  SET_PAGINATED_RESOURCE_PRESERVE_SELECTED_OPTIONS(state, { key, resourceData, selectedOptions = [], dataProp = 'value', pagination:responsePagination, reset}) {
    if(!Array.isArray(selectedOptions)){
      selectedOptions = [selectedOptions]
    }
    let optionValues = []
    if(reset) {
      state[key].isInitiated = false
      state[key].data = [...[], ...selectedOptions]
      state[key].pagination = {...pagination}
      optionValues = selectedOptions.map(item => item?.[dataProp])
    }
    resourceData.forEach(query => !optionValues.includes(parseInt(query?.[dataProp])) && state[key].data.push(query))
    state[key].pagination = { ...state[key].pagination, ...responsePagination }
    state[key].isInitiated = true
  },

  RESET_PAGINATED_RESOURCE(state, key) {
    state[key].isInitiated = false
    state[key].isBusy = false
    state[key].data = []
    state[key].pagination = {...pagination}
  },

  SET_SINGLE_RESOURCE(state, {key, payload}) {
    state[key] = {...payload, ...{ isBusy: false, errorMessage: '' }}
  },

  RESET_SINGLE_RESOURCE(state, key) {
    state[key] = key === 'search' ? query : key == 'group' ? groupQuery : tagSearchQuery
    state[key].isBusy = false
    state[key].errorMessage = ''
  },

  UPDATE_SINGLE_RESOURCE(state, {key, payload}) { // update resource in "query" / "group"
    state[key] = {...payload, ...{ isBusy: false }}
  },

  INSERT_RESOURCE_INTO_LIST(state, {key, payload}) {
    state[key].data.unshift(payload)
  },

  UPDATE_LIST_RESOURCE(state, {key, payload}) { // update resource in "queries" / "group_library"
    const idX = state[key].data.findIndex(resource => resource.id === payload.id)
    if(idX !== -1) state[key].data.splice(idX, 1, payload)
  },

  REMOVE_LIST_RESOURCE(state, { key='searches', item }) { // key = [ 'searches', 'group_library', etc ]
    if(!item) return
    const idX = state[key].data.findIndex(stateItem => stateItem.id === item.id)
    if(idX !== -1) state[key].data.splice(idX, 1)
  },

  REMOVE_QUERY(state, {key='searches', query}) { // key = [ 'searches', 'excludeQueries' ]
    if(!query) return
    const idX = state[key].data.findIndex(item => item.id === query.id)
    if(idX !== -1) state[key].data.splice(idX, 1)
  },

  SET_WINDOW_IS_RESIZING(state, payload) {
    state.isResizing = payload
  },

  MERGE_SELECTED_OPTIONS(state, { key, options }) {
    const dataValues = state[key].data.map(item => item.value)
    options.forEach(option => !dataValues.includes(option.value || option.id) && state[key].data.push(option))
  },

  SET_RESOURCE_VALIDATION(state, { type, payload }) {
    state.query_validity.queryType= type;
    state.query_validity.isValid = payload.valid;
    state.query_validity.errorMessage = payload.custom_message;
  },

  SET_GROUP_RENAME_DELETE_REFUSED (state, {item, payload, action}) {
    state.group_blocked.group_id = (item && item.id) || null;
    state.group_blocked.groups = (payload && payload.groups) || [];
    state.group_blocked.searches = (payload && payload.searches) || [];
    state.group_blocked.action = action;
  },

  SET_SAVE_ERROR (state, { key, message }) {
    state[key].errorMessage = message;
  },

  SET_POLLING_UID (state, uid) {
    state.searches.pollingUid = uid;
  }
}

const getters = {}

const actions = {

  // 1. getPaginatedResource
  getPaginatedResource({ commit, state: { project_id } }, {key, url, extraFilters = {}}) { // key is the resource you update in this file (e.g. "searches", "group_library", "outlets" - paginated resource)
    let { page, total_pages, per_page } = state[key].pagination
    const localPagination = { page, per_page }
    const { filters } = state[key]

    return new Promise((resolve, reject) => {

      if(page && page >= total_pages) reject()
      commit('SET_BUSY', {key, value: true})
      if(key === 'tag_library' && url && state[key].sorted) extraFilters.sortTagsSearches = state[key].sorted;
      // url is base either on the provide "url" or on "key": `projects/${project_id}/${key}`
      if(!url) {
        if(key == 'tag_library') {
          url = `projects/${project_id}/searches/tag_library`;
        } else {
          url = `projects/${project_id}/${key}`;
        }
      }

      axios.get(getNextPageUrl(url, localPagination, {...filters, ...extraFilters}))
        .then(({data : { status, data : { data: resourceData, pagination } }}) => {

          // reset pagination response to snake_case format
          pagination = {
            page: pagination.currentPage,
            total_count: pagination.totalCount,
            total_pages: pagination.totalPages,
            per_page: pagination.perPage || per_page
          }
          commit("SET_PAGINATED_RESOURCE", { key, resourceData, pagination, reset : pagination.page === 1})

          if(key === 'last_activities') commit('SET_RELOAD_LAST_ACTIVITY', false)

          resolve()
        })
        .catch((e) => reject(e))
        .finally(() => {
          commit('SET_BUSY', {key, value: false})
          commit('SET_INITIATE_STATE', {key, value: true})
        })
    })
  },

  // get data for resource without pagination
  getResources({commit}, {key, url}) {
    return new Promise((resolve, reject) => {
      commit('SET_BUSY', {key, value: true})
      axios.get(url)
        .then(({data: {data: {data}}}) => {
          commit("SET_RESOURCE", { key, data })
        })
        .finally(() => commit('SET_BUSY', {key, value: false}))
    })
  },

  // 2. getSingleResource
  getSingleResource({ commit }, { url, key }) { // key: "query", "group", // url: fraction of url (e.g. searches/5)
    commit('SET_BUSY', {key, value: true})

    return new Promise((resolve, reject) => {

      axios.get(url)
        .then(({data}) => {
          const { status, data: payload } = data
          commit('SET_SINGLE_RESOURCE', { key, payload })
          resolve(payload)
        })
        .catch(() => reject())
        .finally(() =>
          commit('SET_BUSY', { key, value: false })
        )
    })
  },

  // 3. createResource
  createResource({commit, state: { project_id }}, { key, model, url }) { // key: "query", "group"
    const singleKey = key === 'searches' && 'search'|| key === 'tag_library' && 'tagSearch' || 'group';

    url = url ? url : `projects/${project_id}/${key}`

    commit('SET_BUSY', {key: null, value: true});
    commit('SET_SAVE_ERROR', { key, message: '' });

    return new Promise((resolve, reject) => {
      axios.post(url, model)
        .then(({data: { status, data: payload}}) => {
          if(!isUndefined(payload.valid) && payload.valid === false && payload.custom_message) {
            commit('SET_SAVE_ERROR', { key: singleKey, message: payload.custom_message });
          }
          else {
            if(singleKey === 'group') { commit('SET_GROUP_RENAME_DELETE_REFUSED', {}); }
            commit('SET_SINGLE_RESOURCE', { key: singleKey, payload })
            commit('INSERT_RESOURCE_INTO_LIST', { key, payload })
            commit('SET_RELOAD_LAST_ACTIVITY', true)
            if(key == 'tag_library') {
              let newCategory = true;
              state[key].countByCategory = state[key].countByCategory.map(category => {
                if(category.category === payload.category) {
                  category.count = +category.count + 1;
                  newCategory = false;
                }
                return category;
              });
              if (newCategory) state[key].countByCategory.push({category: payload.category, count: 1});
            }
          }

          resolve(payload)
        })
        .catch(() => reject())
        .finally(() => commit('SET_BUSY', {key: null, value: false}))
    })
  },

  // 4. editResource
  editResource({commit}, { model, key, url }) { // key: "query", "group"
    const listKey = key === 'search' && 'searches' || key === 'tagSearch' && 'tag_library' || 'group_library';
    commit('SET_BUSY', {key, value: true})
    commit('SET_SAVE_ERROR', { key, message: '' });

    return new Promise((resolve, reject) => {

      axios.put(url, model)
        .then(({data: { status, data: payload }}) => {
          if(!isUndefined(payload.valid) && payload.valid === false) {
            if(['group_library', 'group'].indexOf(key) !== -1 && payload.error_code === 'group_in_use') {
              commit('SET_GROUP_RENAME_DELETE_REFUSED', { item: model, payload, action: 'edit' });
            }
            else if(payload.custom_message) {
              commit('SET_SAVE_ERROR', { key, message: payload.custom_message });
            }
          }
          else {
            if(listKey === 'group_library') { commit('SET_GROUP_RENAME_DELETE_REFUSED', {}); }
            commit('UPDATE_SINGLE_RESOURCE', {key, payload})
            commit('UPDATE_LIST_RESOURCE', {key: listKey, payload})
            commit('SET_RELOAD_LAST_ACTIVITY', true)
            if(listKey == 'tag_library' && payload.oldCategory) {
              let newCategory = true;
              state[listKey].countByCategory = state[listKey].countByCategory.map(category => {
                if(category.category === payload.oldCategory) {
                  category.count = +category.count - 1;
                }
                if(category.category === payload.category) {
                  category.count = +category.count + 1;
                  newCategory = false;
                }
                return category;
              });
              if (newCategory) state[listKey].countByCategory.push({category: payload.category, count: 1});
            }
          }

          resolve()
        })
        .catch(() => reject())
        .finally(() =>
          commit('SET_BUSY', { key, value: false })
        )
    })
  },

  // 5. deleteResource
  deleteResource({commit, state: { project_id }}, { key, item }) { // key: "searches", "group"
    key = key === 'search' && 'searches' || key === 'tagSearch' && 'tag_library' || key === 'group' && 'group_library' || key;
    commit('SET_DELETING', { key, item })

    const urlKey = key === 'searches' ? 'searches' : key === 'group_library' ? 'searches/group_library' : 'searches/tag_library'

    return new Promise((resolve, reject) => {

      axios.delete(`/projects/${project_id}/${urlKey}/${item.id}`)
        .then(({data}) => {
          let payload = data.data;
          if(key === 'group_library' && payload && payload.valid === false) {
            commit('SET_GROUP_RENAME_DELETE_REFUSED', { item, payload, action: 'delete' });
          } else {
            commit('REMOVE_LIST_RESOURCE', { key, item });
            commit('SET_RELOAD_LAST_ACTIVITY', true)
            if(key === 'group_library') { commit('SET_GROUP_RENAME_DELETE_REFUSED', {}); }
            if(key == 'tag_library') {
              state[key].countByCategory = state[key].countByCategory.map(category => {
                if(category.category === item.category) {
                  category.count = +category.count - 1;
                }
                return category;
              });
            }
          }

          resolve()
        })
        .catch(() => reject())
        .finally(() =>
          commit('SET_DELETING', { key, item: null })
        )
    })
  },

  // 6. exportResource
  exportResource({commit, state: { project_id }}, { item, formatType='csv', key, filters = {} }) {
    commit('SET_EXPORTING', { isExporting: item || true })

    let url = `/projects/${project_id}/searches/export/${formatType}`;
    if(item) {
      url += `/${item}`;
    }

    if (filters && Object.keys(filters).length > 0) {
      url += `?${filtersToQuery(filters)}`;
    }

    return new Promise((resolve, reject) => {
      axios.get(url, {
        responseType: 'blob'
      })
        .then(response => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          const timestamp = moment().format('YYYYMMDD');
          link.setAttribute('download', `searches_export_${item ? item+'_' : ''}${timestamp}.${formatType}`)
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          resolve();
        })
        .catch(() => reject())
        .finally(() =>
          commit('SET_EXPORTING', { isExporting: false })
        )
    });
  },

  exportTags({commit, state: { project_id, client_id }}, { item, formatType='csv', filters = {}}) {
    commit('SET_EXPORTING', { isExporting: item || true })
    let url = `/projects/${project_id}/searches/tag_library/export/${formatType}`
    if (filters && Object.keys(filters).length > 0) {
      url += `?${filtersToQuery(filters)}`;
    }
    return new Promise((resolve, reject) => {
      axios.post(url, {tags: item, clientId: client_id}, {
        responseType: 'blob'
      }).then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        const timestamp = moment().format('YYYYMMDD');
        link.setAttribute('download', `tags_export_${timestamp}.${formatType}`)
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        resolve();
      })
        .catch(() => reject())
        .finally(() =>
          commit('SET_EXPORTING', { isExporting: false })
        )
    });
  },

  getTagsCategories({commit},{key, url}) {
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(({data: {data}}) => {
          commit("SET_TAG_CATEGORIES", { key, data })
        })
    })
  },

  getMoreTagsByCategory({commit}, {category, offset, search, orderBy, projectId}) {
    const url = `projects/${projectId}/searches/tag_library/loadByCategory`
    const visibility = state.tag_library.filters.visibility;
    return new Promise((resolve, reject) => {
      axios.get(url, { params: { category, offset, search, orderBy, visibility } })
        .then(({data: {data}}) => {
          commit("ADD_MORE_TAGS_BY_CATEGORY", { key: 'tag_library', data })
          return resolve(data)
        })
    })
  },

  getSearchCompatibleTags({commit}, {projectId, query}) {
    const url = `projects/${projectId}/searches/compatible_tags?query=${query}&only_linked=true`
    return new Promise((resolve, reject) => {
      axios.get(url)
        .then(({data: {data}}) => {
          commit("TAGS_BY_SEARCH", { data })
          return resolve(data)
        })
    })
  },

  batchCloneTags({commit}, {tags, projectId, newProjectId, clientId}) {
    commit('SET_BUSY', {key: 'tag_library', value: true})
    let url = `projects/${projectId}/searches/tag_library/batchClone/${newProjectId}`;

    return new Promise((resolve, reject) => {
      commit('SET_CLONING_ERROR', false);
      axios.post(url, { tags, clientId })
        .then(({data: {data}}) => {
          if(!data.valid) commit('SET_CLONING_ERROR', data.custom_message);
          else commit('SET_CLONING_ERROR', false);
          return resolve(data)
        }).catch((error) => {
          commit('SET_CLONING_ERROR', 'Something went wrong. Please try again later.');
          return reject()
        }).finally(() => {
          commit('SET_BUSY', {key: 'tag_library', value: false});
          commit('SET_RELOAD_LAST_ACTIVITY', true);
        });
    })
  },

  batchDeleteTags({commit}, {tagsIds, projectId, removedFromEachCategory}) {
    commit('SET_BUSY', {key: 'tag_library', value: true})
    let url = `projects/${projectId}/searches/tag_library/batchDelete`;

    return new Promise((resolve, reject) => {
      axios.post(url, { tagsIds })
        .then(({data: {data}}) => {
          commit('DELETE_TAGS', { tagsIds, removedFromEachCategory });
          return resolve(data)
        }).catch((error) => {
          return reject()
        }).finally(() => {
          commit('SET_RELOAD_LAST_ACTIVITY', true);
          commit('SET_BUSY', {key: 'tag_library', value: false});
        });
    })
  },

  /**
   * tagUpdates object param should have the following
   * {
   *  "tags_to_link": [ 8580175],
   *  "tags_to_unlink": [8580296, 8580295],
   *  "tag_to_create": [
   *    { "name": "Brand New Tag234", "category": "Competitors", "is_private": false },
   *    { "name": "Another Tag234", "category": "Competitors", "is_private": true }
   *  ]
   * }
   */
  batchSaveSearchLinkedTags({commit}, {projectId, searchId, tagUpdates}) {
    commit('SET_BUSY', {key: 'tag_library', value: true})
    let url = `projects/${projectId}/searches/tag_library/batch_linked_tags`;

    return new Promise((resolve, reject) => {
      commit('SET_LINKED_TAGS_ERROR', false);
      axios.post(url, { search_id: searchId, ...tagUpdates })
        .then(({data: {data}}) => {
          if(!data.valid) commit('SET_LINKED_TAGS_ERROR', data.custom_message);
          // commit('SAVE_LINKED_TAGS');
          return resolve(data);
        }).catch((error) => {
          commit('SET_CLONING_ERROR', i18n.t('messages.request.error'));
          return reject()
        }).finally(() => {
          commit('SET_RELOAD_LAST_ACTIVITY', true);
          commit('SET_BUSY', {key: 'tag_library', value: false});
        });
    })
  },

  getOrderedTags({commit}, {orderBy, search, projectId, visibility, toggleVisibility = false}) {
    commit('SET_BUSY', {key: 'tag_library', value: true})
    if(toggleVisibility) {
      visibility = visibility === undefined && 'private' || visibility === 'private' && 'public' || undefined;
      commit('SET_FILTER_PARAM', {key: 'tag_library', param: {key: 'visibility', value: visibility}})
    }
    const url = `/projects/${projectId}/searches/tag_library/getOrderedTags`
    return new Promise((resolve, reject) => {
      axios.get(url, { params: { orderBy, search, visibility, countTotal: toggleVisibility } })
        .then(({data: {data}}) => {
          commit("SET_RESOURCE", { key: 'tag_library', data, updateTotalCount: toggleVisibility })
          commit('SET_BUSY', {key: 'tag_library', value: false})
        })
    })
  },

  changeTagsSortOrder({commit}, {sort}) {
    commit("SET_TAG_SORT_ORDER", { sort });
  },

  changeTagsVisibility({commit}, {projectId, visible, tagsIds}) {
    const url = `/projects/${projectId}/searches/tag_library/changeVisibility`
    return new Promise((resolve, reject) => {
      axios.post(url, { private: !visible, tagsIds })
        .then(({data: {data}}) => {
          if (!data.valid) return reject(
            {
              custom_message: data.custom_message
            }
          );
          commit('CHANGE_TAGS_VISIBILITY', { tagsIds, visible })
          commit('SET_RELOAD_LAST_ACTIVITY', true);
          return resolve(data)
        })
        .catch((e) => reject(e))
    })
  },

  // to get a first page, reset pagination before calling this fn
  // update your filters before calling this function
  searchGenericPaginatedResource({commit}, {key, url, extraFilters = {}, selectedOptions, dataProp = '', resetPagination = true}) {

    return new Promise((resolve, reject) => {
      if(!url) return reject('No url endpoint provided')

      commit('SET_BUSY', {key, value: true})

      let { page, total_pages, per_page } = resetPagination ?  pagination : state[key].pagination
      const localPagination = { page, per_page }
      const { filters } = state[key]

      if(page && page >= total_pages) reject()

      axios.get(getNextPageUrl(url, localPagination, {...filters, ...extraFilters}))
        .then(({data}) => {
          let { status, data : { data: resourceData, pagination } } = data

          pagination = {
            page: pagination.currentPage,
            total_count: pagination.totalCount,
            total_pages: pagination.totalPages,
            per_page: pagination.perPage || per_page
          }

          commit("SET_PAGINATED_RESOURCE_PRESERVE_SELECTED_OPTIONS", { key, resourceData, selectedOptions, pagination, dataProp, reset : pagination.page === 1})
          resolve(data)
        })
        .catch(() => reject())
        .finally(() => {
          commit('SET_BUSY', {key, value: false})
        })
    })
  },


  validateQuery ({commit, state: { project_id }}, { type, model, isTagSearch }) {
    //If a request was already sent, cancel it to make sure that the response we have is of last request
    if(state.query_validity && state.query_validity.isBusy) {
      this.validateToken.cancel('Another request triggered');
    }

    const CancelToken = axios.CancelToken;
    this.validateToken = CancelToken.source();

    commit('SET_BUSY', {key: 'query_validity', value: true})
    return new Promise((resolve, reject) => {
      // FIXME: This is temporary "Duncan Abela"
      axios.post(`projects/${project_id}/searches/${isTagSearch ? 'tag_library/': ''}validate?type=${type}`, model, {
        cancelToken: this.validateToken.token
      })
        .then(({data: { status, data: payload}}) => {
          commit('SET_RESOURCE_VALIDATION', { type, payload })
          resolve(payload);
        })
        .catch((err) => {
          if(!axios.isCancel(err)) {
            reject();
          }
        })
        .finally(() => {
          commit('SET_BUSY', {key: 'query_validity', value: false})
        })
    })
  },

  autocompleteQuery({commit, state: {project_id}}, {query, searchType, isMulti, isStandardQuery, groupId}) {
    if(!query || query === "") return
    return new Promise((resolve, reject) => {
      axios.get(`/projects/${project_id}/searches/group_library/autocomplete?query=${query}${isMulti ? '&is_multi=true' : ''}${searchType ? '&type='+ searchType : ''}${isStandardQuery ? '&is_standard_query='+ isStandardQuery : '' }${groupId ? '&group_id='+ groupId : ''}`)
        .then(({data}) => {
          resolve(data)
        })
        .catch(() => reject())
    })
  },

  cloneResource({commit, state: { project_id, client_id }}, {cloneToId, key, searchId, name}) {
    if(!cloneToId) return;

    const isGroup = ['group_library', 'group'].indexOf(key) !== -1;
    const isTagSearch = ['tag_library', 'tagSearch'].indexOf(key) !== -1;
    const resourceUrl = isGroup ? '/group_library' : isTagSearch ? '/tag_library' : '';
    let url = `/projects/${project_id}/searches${resourceUrl}/clone/${searchId}`

    let params = [];
    let paramKey = isGroup ? 'client_id' : 'project_id';
    params.push(`${paramKey}=${cloneToId}`)
    if(name) params.push(`name=${name}`)
    if(params) url += `?${params.join('&')}`

    return new Promise((resolve, reject) => {
      commit('SET_CLONING', true)
      commit('SET_CLONING_ERROR', false);
      axios.post(url)
        .then(({data: {status, data}}) => {
          if(data.valid !== undefined && data.valid === false) {
            commit('SET_CLONING_ERROR', data.custom_message);
          }
          else {
            if((!isGroup && cloneToId.toString() === project_id) ||
              (isGroup && cloneToId.toString() === client_id)) {

              let clonedKey = isGroup ? 'group_library' : isTagSearch ? 'tag_library' : 'searches';
              commit('INSERT_RESOURCE_INTO_LIST', { key: clonedKey, payload: isGroup ? data[0] : data })
              commit('SET_RELOAD_LAST_ACTIVITY', true);
            }
          }
          resolve(data)
        })
        .catch(() => reject())
        .finally(() => commit('SET_CLONING', false))
    })
  },

  getStates({commit}, stateKey) {
    axios.get(`/countries/${stateKey}/states`)
      .then(({data: {data}}) => commit('SET_STATES', data))
      .catch((e) => console.log(e))
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
};